import React, {Component} from 'react';
import {AssignBusinessUnitLabelsModal} from "./AssignBusinessUnitLabelsModal";
import {FaIcon} from "../FaIcon";

export class AssignBusinessUnitLabelsButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    // rendering

    renderModal() {
        if (this.state.modal) {
            return <AssignBusinessUnitLabelsModal isOpen={this.state.modal} toggle={this.toggle}
                                                  businessUnitName={this.props.businessUnitName}
                                                  businessUnitLabels={this.props.businessUnitLabels}
                                                  businessUnitId={this.props.businessUnitId}
                                                  onLabelsChange={this.props.onLabelsChange}
            />;
        } else {
            return null;
        }
    }

    renderButton() {
        return (
            <button onClick={this.toggle} className="bu-cell-button tags-modal">
                <FaIcon iconName="tags"/>
            </button>
        )
    }

    render() {
        return (
            <div>
                {this.renderButton()}
                {this.renderModal()}
            </div>
        );
    }
}

